import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/lib/auth";
import { formatErr } from "@/lib/api";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";
import Nav from "@/components/Nav";

export default function Register() {
  const { register } = useAuth();
  const nav = useNavigate();
  const [form, setForm] = useState({ name: "", email: "", password: "" });
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await register(form.email, form.password, form.name);
      nav("/mon-espace");
    } catch (err) {
      setError(formatErr(err.response?.data?.detail) || "Inscription impossible");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#F9F9F6]">
      <Nav />
      <div className="mx-auto max-w-md px-6 py-24">
        <p className="mb-4 text-xs font-medium uppercase tracking-[0.32em] text-stone-500">Nouveau membre</p>
        <h1 className="font-display mb-6 text-4xl font-light tracking-tight text-stone-900">Créer un compte</h1>
        
        {/* Invitation-only banner */}
        <div className="mb-8 rounded-2xl border border-amber-200 bg-amber-50 p-6">
          <p className="text-sm font-medium text-amber-900 mb-2">Inscriptions sur invitation uniquement</p>
          <p className="text-sm text-amber-800">
            Pour devenir membre, contactez Samuel au <strong className="font-semibold">06.68.49.77.50</strong> ou par email à <strong className="font-semibold">samuel.b1992@gmail.com</strong>
          </p>
        </div>
        
        <p className="text-sm text-stone-600 mb-6">Déjà membre ? Vous avez reçu vos identifiants par email.</p>
        
        <form onSubmit={submit} className="space-y-6">
          <div>
            <Label htmlFor="name">Prénom</Label>
            <Input data-testid="register-name" id="name" value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} required className="mt-2 h-12 bg-white" />
          </div>
          <div>
            <Label htmlFor="email">Email</Label>
            <Input data-testid="register-email" id="email" type="email" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} required className="mt-2 h-12 bg-white" />
          </div>
          <div>
            <Label htmlFor="password">Mot de passe</Label>
            <Input data-testid="register-password" id="password" type="password" minLength={6} value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })} required className="mt-2 h-12 bg-white" />
            <p className="mt-1 text-xs text-stone-500">6 caractères minimum</p>
          </div>
          {error && <p data-testid="register-error" className="rounded-md bg-red-50 px-4 py-3 text-sm text-red-700">{error}</p>}
          <Button data-testid="register-submit" type="submit" disabled={loading} className="w-full rounded-full bg-stone-900 py-6 hover:bg-stone-800">
            {loading ? "Création…" : "Créer mon compte"}
          </Button>
        </form>
        <p className="mt-8 text-sm text-stone-500">
          Déjà un compte ? <Link to="/login" className="text-stone-900 underline underline-offset-4">Se connecter</Link>
        </p>
      </div>
    </div>
  );
}
